// @flow
import React, { PureComponent } from 'react';

import { MOBILE_SIZE } from 'constants/app';
import type { FullUserType } from 'types/User';
import { handleTagEvent } from 'utils/tagManagerUtils';

export type StateProps = {
  pushevent: {
    lien: string,
    title: string,
    background: string,
    background_mobile: string,
    description: string,
    cta: string,
    classsup: string,
  },
  userPref: FullUserType,
};

type Props = StateProps;

class PushEvent extends PureComponent<Props> {
  render() {
    const {
      pushevent,
      pushevent: {
        lien,
        title,
        background,
        background_mobile,
        cta,
        description,
        classsup
      },
      userPref,
    } = this.props;
    const classNames = `box card card--hub-alt card--small card--xSmall `+classsup;
    let background_final = background;
    if (window.innerWidth <= MOBILE_SIZE && background_mobile) {
        background_final = background_mobile;
    }
    if (pushevent && pushevent.lien) {
      return (
        <section className="container mt-7">
        <div className="row mb-2">
            <div className="col">
              <a
                href={lien}
                onClick={handleTagEvent(
                    'module_ecosysteme',
                    lien,
                    '',
                    userPref
                )}
                title={title}
                rel="noopener noreferrer"
                className={classNames}>
                <div
                    className="card__thumbnail"
                    style={{ backgroundImage: `url(${background_final})` }}>
                    <img src={ background_final } alt="" />
                </div>
                <div className="card__body">
                    {title && 
                    <h3 className="card__title" dangerouslySetInnerHTML={{__html: title.replace('Noël', '<span>Noël</span>')}} />}
                    {description && 
                    <p className="card__desc ft-secondary">
                    {description}
                    </p>}
                </div>
                <div className="card__footer">
                  {cta &&
                  <span className="btn btn--primary">
                      <span>{cta }</span>
                  </span>}
                </div>
            </a>
            </div>
        </div>
        </section>
      );
    }
    return null;
  }

};

export default PushEvent;
